import { toast } from "react-toastify";
import {
  addCustomerService,
  deleteCustomerService,
  editCustomerService,
  getCustomersListService,
} from "../../Services/CustomerService";
import {
  addCustomerFailure,
  addCustomerStart,
  addCustomerSuccess,
  deleteCustomerFailure,
  deleteCustomerStart,
  deleteCustomerSuccess,
  editCustomerFailure,
  editCustomerStart,
  editCustomerSuccess,
  fetchCustomersFailure,
  fetchCustomersStart,
  fetchCustomersSuccess,
} from "./reducer";

//thunk for fetch the category list
export const fetchCustomersList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchCustomersStart());
      const response = await getCustomersListService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchCustomersSuccess({
            customers: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchCustomersSuccess({
            customers: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchCustomersFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchCustomersFailure(error));
    }
  };

// //thunk for the addig the category

export const addCustomer = (requestParam) => async (dispatch) => {
  try {
    dispatch(addCustomerStart());

    const response = await addCustomerService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addCustomerSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addCustomerFailure("Failed to add customer"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addCustomerFailure());
  }
};

// //this is the thunk for delete the category
export const deleteCustomer = (customerId) => async (dispatch) => {
  try {
    dispatch(deleteCustomerStart());

    const response = await deleteCustomerService(customerId);

    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteCustomerSuccess(categoryId));
    } else {
      toast.error("Failed to delete customer");
      dispatch(deleteCustomerFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteCustomerFailure(error));
  }
};

// //this tunk for the edit meal category
export const updateCustomer = (id, requestParam) => async (dispatch) => {
  try {
    dispatch(editCustomerStart());
    const response = await editCustomerService(id, requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(editCustomerSuccess(response));
    } else {
      dispatch(editCustomerFailure("Failed to update customer"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editCustomerFailure(error));
  }
};

// //this thunk is for the get by id
// export const fetchMealCategoryById = (id) => async (dispatch) => {
//   try {
//     dispatch(getCategoryByIdStart());
//     const response = await getCategoryByIdService(id);
//     if (response?.data) {
//       dispatch(getCategoryByIdSuccess(response.data));
//     } else {
//       dispatch(getCategoryByIdFailure("No category found"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(getCategoryByIdFailure(error));
//   }
// };
